export const trials: Record<string, Record<string, string>> = {
  inmunebio: { MINDFuL: "NCT05318976" },
  bridgebio: { PROPEL: "NCT05145010" },
  demo: {
    DARATUMUMAB: "DARATU-ALZ",
    ASCENT_MDD: "DEMO_TRIAL2",
    NOVA_MS: "DEMO_TRIAL3",
  },
  acadia: {
    "ACP-211-002": "ACP-211-002",
    "ACP-204-012": "ACP-204-012",
    "ACP-204-013": "ACP-204-013",
  },
};
